module.exports = __webpack_public_path__ + "img/Smart-Rooms.79c4ffed.svg";